var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import AbortController from 'abort-controller';
import { exponentialBackoffScheduler, } from '../../utils/asyncTaskSchedulers';
// Can be thrown to indicate that the request was valid, but the server has
// decided not to fulfill it. Typical rejection reasons include Not Found,
// Forbidden, and other 400-series errors.
var Rejection = /** @class */ (function () {
    function Rejection(rejection) {
        this.rejection = rejection;
    }
    return Rejection;
}());
export { Rejection };
// Can be thrown to signal that the loader should retry again at a time of its
// choosing, optionally with a promise that indicates the earliest possible
// time.
var Retry = /** @class */ (function () {
    function Retry(noEarlierThan) {
        this.noEarlierThan = noEarlierThan;
    }
    return Retry;
}());
export { Retry };
export var defaultResourceOptions = {
    loadScheduler: exponentialBackoffScheduler({
        maxRetries: 10,
    }),
};
export function extractSchematicResourceOptions(options) {
    var _a = __assign(__assign({}, defaultResourceOptions), options), load = _a.load, loadScheduler = _a.loadScheduler, rest = __rest(_a, ["load", "loadScheduler"]);
    return [{ load: load, loadScheduler: loadScheduler }, rest];
}
export function createSchematicResource(options) {
    var _this = this;
    var _a = __assign(__assign({}, defaultResourceOptions), options), loadOption = _a.load, loadScheduler = _a.loadScheduler, schematic = _a.schematic;
    var load = loadOption && wrapLoad(loadOption);
    var request = function (vars, context) {
        var schematicInstance = schematic(vars);
        var selection = schematicInstance.selection;
        var abortController = new AbortController();
        if (!selection) {
            throw new Error('Resource Error: Could not compute selection from resource vars.');
        }
        return {
            root: selection.root,
            select: function (pickerSource) {
                return pickerSource.map(function (pick) {
                    return schematicInstance.build(selection, pick);
                });
            },
            load: function (actions) {
                if (!load) {
                    return actions.abandon();
                }
                var handle = loadScheduler(function (complete, retry) { return __awaiter(_this, void 0, void 0, function () {
                    var input, something_1, rejection;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, load(vars, context, abortController.signal)];
                            case 1:
                                input = _a.sent();
                                actions.update(schematicInstance.chunk(input).chunks);
                                complete();
                                return [3 /*break*/, 3];
                            case 2:
                                something_1 = _a.sent();
                                if (something_1 instanceof Rejection) {
                                    rejection = something_1.rejection;
                                    actions.update([
                                        __assign(__assign({}, selection.root), { payload: { type: 'rejection', rejection: rejection } }),
                                    ]);
                                }
                                else if (something_1 instanceof Retry) {
                                    retry(something_1.noEarlierThan);
                                }
                                else {
                                    throw something_1;
                                }
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); });
                handle.result
                    .then(function (result) { return result.status === 'abandoned' && actions.abandon(); })
                    .catch(actions.error);
                return function () {
                    // Cancel before abort, as abort may cause a fetch to throw an error,
                    // and cancelling first will ensure that error is ignored.
                    handle.cancel();
                    abortController.abort();
                };
            },
        };
    };
    var resourceSchematic = function (vars) {
        if (vars === void 0) { vars = undefined; }
        return schematic(vars);
    };
    return Object.assign(resourceSchematic, { request: request });
}
function wrapLoad(load) {
    var _this = this;
    var loadFn = typeof load === 'function' ? load : function () { return load; };
    return function (vars, context, signal) {
        if (context === void 0) { context = {}; }
        return __awaiter(_this, void 0, void 0, function () {
            var promiseOrRequest, url, fetchOptions, fetch, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promiseOrRequest = loadFn(vars, context, signal);
                        if (isPromise(promiseOrRequest)) {
                            return [2 /*return*/, promiseOrRequest];
                        }
                        url = typeof promiseOrRequest === 'string'
                            ? promiseOrRequest
                            : promiseOrRequest.url;
                        fetchOptions = __assign(__assign({}, context.fetchOptions), (typeof promiseOrRequest === 'string' ? undefined : promiseOrRequest));
                        fetch = context.fetch || window.fetch;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, fetch(url, fetchOptions)];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.json()];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        if (response.status >= 400 && response.status < 500) {
                            throw new Rejection(response.statusText);
                        }
                        else {
                            throw new Retry();
                        }
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_1 = _a.sent();
                        console.error('Error fetching resource data:', error_1);
                        throw new Retry();
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
}
function isPromise(x) {
    return x && x.then;
}
//# sourceMappingURL=schematicResource.js.map